import {throttleEvent} from "../module/throttle-event.function";

export class InViewportClass {
    private readonly scrollElementSelector= '.js-window-scroll';
    private elements: { el: HTMLElement, callback: any, removeAfterView: boolean, gap: number }[] = [];
    private readonly gap = 200;
    constructor() {
        const scrollListener = throttleEvent(() => {
            this.checkViewport();
        }, 300);
        document.querySelector(this.scrollElementSelector).addEventListener('scroll', scrollListener);
    }

    addElement (selector: string|HTMLElement, callback: any, removeAfterView = true, gap = this.gap): void {
        const el = typeof selector === 'string' ? document.querySelector<HTMLElement>(selector) : selector;
        if (el) {
            this.elements.push({
                el,
                callback,
                removeAfterView,
                gap,
            });
        }

        this.checkViewport();
    }

    checkViewport(): void {
        const toBeRemoved: number[] =  [];
        this.elements
            .filter((elemConfig, key) => {
                const visible = this.isInViewport(elemConfig.el, elemConfig.gap);
                if (visible && elemConfig.removeAfterView) {
                    toBeRemoved.push(key);
                }
                return visible;
            })
            .forEach(elemConfig => elemConfig.callback(elemConfig.el));
          toBeRemoved.forEach(key => this.elements.splice(key, 1));
    }

    private isInViewport(el: HTMLElement, gap: number): boolean {
        const bounding = el.getBoundingClientRect();
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;
        return (
            bounding.width > 0 && bounding.height > 0 &&
            (bounding.top - gap <= 0 || bounding.bottom + gap <= windowHeight)
        );
    }
}
